import { Plus } from "lucide-react";

export default function BlankProductCard({ onClick }) {
  return (
    <div
      onClick={onClick}
      className="relative flex flex-col bg-zinc-50 border-2 border-dashed border-zinc-300 rounded-md hover:border-blue-500 hover:bg-blue-50 transition-all duration-200 cursor-pointer group active:scale-95 select-none h-full"
      data-testid="blank-product-card"
    >
      <div className="flex flex-col items-center justify-center h-full">
        <Plus className="w-8 h-8 text-zinc-400 group-hover:text-blue-600 mb-2" />
        <p className="text-xs text-zinc-500 group-hover:text-blue-600 font-medium">
          Add Product
        </p>
      </div>
    </div>
  );
}
